import React, { useCallback, useMemo, useState } from "react";
import CustomBreadcumbs from "../../../../component/atoms/custom-breadcumbs";
import TitlePages from "../../../../component/atoms/title-pages";
import { IconFilterReport } from "../../../../asset";
import DrawerReportTrip from "./__components/drawer";
import TableReportOrderNoData from "../report-order/__components/table/table-report-order-no-data";
import { useSelector } from "react-redux";
import { POSTGetListReportServices } from "../../../../service/POSTGetListReport";
import {
  EXPORT_TRIP_REPORT,
  LIST_TRIP_REPORT,
} from "../../../../api/contractAPI.api";
import { message } from "antd";
import TableTripReport from "./__components/tables-wtih-data";
import { doExport } from "../../../../api/baseAPI";

const MainReportTrip = () => {
  const { token } = useSelector((state) => state.auth);

  const { globalDDLDatePeriod } = useSelector((state) => state.globalDDL);
  const { valuesMultipleSelectTripStatus } = useSelector(
    (state) => state.globalMultipleSelectValues
  );

  const { globalDepotName, globalTrip } = useSelector(
    (state) => state.globalMSS
  );

  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  const [listData, setListData] = useState([]);
  const [statePayload, setStatePayload] = useState({});

  const onClickFilter = useCallback(() => {
    setIsDrawerOpened(true);
  }, []);

  const onCloseFilter = useCallback(() => {
    setIsDrawerOpened(false);
  }, []);

  const getListReportTrip = useCallback(
    async (newParams, payload) => {
      const newBody = {
        ...payload,
        page: newParams?.page,
        limit: newParams?.limit,
      };
      setStatePayload(newBody);

      const res = await POSTGetListReportServices(
        token,
        LIST_TRIP_REPORT,
        newBody
      );
      if (res?.success) {
        setListData(res?.list);
      } else {
        if (res?.errorCode === 500) {
          message.error(res?.message);
        }
      }
      onCloseFilter();
    },
    [onCloseFilter, token]
  );

  const applyFilter = useCallback(async () => {
    const depots = [...globalDepotName];
    const payloadDepot =
      depots && depots.length === 0
        ? { depot: { list_id: [], exclude: false } }
        : depots && depots.includes(-1)
        ? { depot: { list_id: [-1], exclude: false } }
        : {
            depot: {
              list_id: depots.map((el) => el?.id),
              exclude: false,
            },
          };

    const datePeriod = globalDDLDatePeriod;
    const payloadDatePeriod = {
      ...datePeriod,
    };

    const tripStatus = [...valuesMultipleSelectTripStatus];
    const payloadTripStatus =
      tripStatus && tripStatus.length === 0
        ? { trip_status: { list: ["ALL"], exclude: false } }
        : tripStatus && tripStatus.includes(-1)
        ? { trip_status: { list: ["ALL"], exclude: false } }
        : {
            trip_status: {
              list: tripStatus.map((el) => el?.id),
              exclude: false,
            },
          };

    const trips = [...globalTrip];
    const payloadTrip =
      trips && trips.length === 0
        ? { trip: { list_id: [], exclude: false } }
        : trips && trips.includes(-1)
        ? { trip: { list_id: [-1], exclude: false } }
        : {
            trip: {
              list_id: trips.map((el) => el?.id),
              exclude: false,
            },
          };

    const payload = {
      page: 1,
      limit: 10,
      order: "",
      filter: "",
      connector: "",
      other: {
        filter_selection: {
          ...payloadDepot,
          period_date: {
            ...payloadDatePeriod,
          },
          ...payloadTripStatus,
          ...payloadTrip,
        },
      },
    };

    const params = { page: 1, limit: 10 };
    await getListReportTrip(params, payload);
  }, [
    getListReportTrip,
    globalDDLDatePeriod,
    globalDepotName,
    globalTrip,
    valuesMultipleSelectTripStatus,
  ]);

  const isBtnExportEnabled = useMemo(() => {
    if (listData && listData.length === 0) {
      return false;
    }
    return true;
  }, [listData]);

  const btnExportOrderReport = useCallback(async () => {
    const { filter_selection } = statePayload?.other;

    const body = {
      filter_selection,
    };

    try {
      const res = await doExport(EXPORT_TRIP_REPORT, token, body);
      if (res?.status === 200) {
        const pdfBlob = new Blob([res?.data]);

        const url = window.URL.createObjectURL(pdfBlob);

        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", `report_trip.pdf`);

        document.body.appendChild(tempLink);
        tempLink.click();

        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
        return;
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        // setIsFailedModalOpen(true);
        // setMessageFailed(error?.message);
        return;
      }
      if (error?.response?.status === 500) {
        message.error("Internal Server Error");
        return;
      }
    }
  }, [statePayload, token]);

  return (
    <>
      <CustomBreadcumbs
        jmlLevel={2}
        menuLevel1={"Report"}
        menuLevel2={"Trip Report"}
      />
      <TitlePages name={"Trip Report"} />
      <div className="flex justify-between mt-5">
        <button
          className={`${
            isBtnExportEnabled ? "btn-export-enabled" : "btn-export-disabled"
          }`}
          onClick={
            isBtnExportEnabled ? () => btnExportOrderReport() : undefined
          }
        >
          Export
        </button>
        <button className="container-btn-filter-report" onClick={onClickFilter}>
          <span className="span-btn-filter-report">Filter</span>
          <img src={IconFilterReport} alt="icon-filter-report" />
        </button>
      </div>
      <div className="container-pages-table">
        {listData?.data?.length > 0 ? (
          <TableTripReport data={listData} />
        ) : (
          <TableReportOrderNoData openFilter={onClickFilter} />
        )}
      </div>
      <DrawerReportTrip
        onClose={onCloseFilter}
        open={isDrawerOpened}
        applyFilter={applyFilter}
      />
    </>
  );
};

export default MainReportTrip;
